// Event handler for opening a dropdown menu
$('.dropdown-menu-toggler').on('click', function () {
  const $otherTogglers = $('header .dropdown-menu-toggler, .collapse .dropdown-menu-toggler').not($(this));

  $otherTogglers.removeClass('active');
  $(this).toggleClass('active');

  $('.dropdown-menu').not($(this).next()).hide(); // Hide other submenus
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $(this).next().slideToggle(); // Show current submenu
  }else{
    $(this).next().fadeToggle(); // Show current submenu
  }
});

// Event handler for clicking a link with a submenu
$('.nav-link.has-dropdown[href="#"]').on('click', function () {
  const $otherTogglers = $('header .dropdown-menu-toggler, .collapse .dropdown-menu-toggler').not($(this).next());

  $otherTogglers.removeClass('active');
  $(this).next().toggleClass('active');

  $('.dropdown-menu').not($(this).next().next()).hide(); // Hide other submenus
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $(this).next().next().slideToggle(); // Show current submenu
  }else{
    $(this).next().next().fadeToggle(); // Show current submenu
  }
});

// Event handler to close when clicked outside
$(document).on('click', function (e) {
  const isDropdownClicked = $(e.target).closest('header .nav-item.dropdown, .collapse .nav-item.dropdown').length !== 0;

  if (!isDropdownClicked) {
    $('.header .dropdown-menu, .header .dropdown-menu-toggler, .collapse .dropdown-menu, .collapse .dropdown-menu-toggler').removeClass('active');
    $('.dropdown-menu').hide();
  }
});
